import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { FileText, Info, Trash2 } from 'react-feather';

import {
    TooltipInformation,
    TooltipApprovalInfo,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const TransactionsTable = ({ useFetchInit }) => {

    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchTransactionsByExpense } = FetchData
    const { dataTransactions, loadingFetchTransactions } = fetchTransactionsByExpense

    const { 
        handleClickShowExpenseTransactionInfo,
        handleClickDeleteTransaction,
        handleClickPrintExtraExpensesTicket
    } = Actions

    const columnConfig = [
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info",
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const {usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
                return(
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "movimiento_fecha", headerName: "FECHA", minWidth: 110, maxWidth: 110, filter: true },
        { 
            field: "movimiento_tipo", headerName: "TIPO", minWidth: 100, maxWidth: 100, filter: true,
            cellClass: (params) => {
                return params.value === 'EFECTIVO' ? 'bg-primary' : 'bg-secondary text-white';
            },
        },
        // { field: "movimiento_monto", headerName: "MONTO", minWidth: 100, maxWidth: 100, filter: true },
        { field: "movimiento_moneda", headerName: "MONEDA", minWidth: 120, maxWidth: 120, filter: true },
        // { field: "movimiento_tipo_cambio", headerName: "CAMBIO", minWidth: 120, maxWidth: 120, filter: true },
        { 
            field: "movimiento_quetzales", headerName: "TOTAL (Q)", minWidth: 120, maxWidth: 120, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { 
            field: "movimiento_dolares", headerName: "TOTAL ($)", minWidth: 120, maxWidth: 120, filter: true,
            cellRenderer: (params) => '$ ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        // { field: "movimiento_observaciones", headerName: "movimiento_observaciones", filter: true },
        { 
            field: "aprobacion_check",
            headerName: "APROBACION",
            minWidth: 175,
            maxWidth: 175,
            filter: true,
            cellStyle: (params) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "left"
            }),
            cellClass: (params) => {

                if(params.value === 'APROBADO') return 'bg-success';
                if(params.value === 'PENDIENTE') return 'bg-warning';
                if(params.value === 'RECHAZADO') return 'bg-danger';

            },
            cellRenderer: (params) => {
                const { value } = params
                const { aprobacion_usuario, aprobacion_fecha } = params.data

                return (
                    <TooltipApprovalInfo
                        texto_approval={value}
                        usuario_approval={aprobacion_usuario}
                        fecha_approval={aprobacion_fecha}
                    />
                );

            }
        },
        {
            headerName: "OPCIONES",
            minWidth: 400,
            cellRenderer: (params) => {
                const {idtransaction, aprobacion_check} = params.data

                return (
                    <CustomDropDown>
                        <MenuItem
                            onClick={() => handleClickShowExpenseTransactionInfo(params.data, true, 'READONLY')}
                        >
                            <ListItemIcon> <Info color="black"/> </ListItemIcon>
                            <ListItemText primary="Ver Info" />
                        </MenuItem>
                        {( ['APROBADO', 'PENDIENTE'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickPrintExtraExpensesTicket(idtransaction)}
                            >
                                <ListItemIcon> <FileText color="black"/> </ListItemIcon>
                                <ListItemText primary="Recibo" />
                            </MenuItem>
                        )}
                        {( ['PENDIENTE'].includes(aprobacion_check) ) && (
                            <MenuItem
                                onClick={() => handleClickDeleteTransaction(idtransaction)}
                            >
                                <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                <ListItemText primary="Eliminar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
                
            }
        },
    ]

    return (
        <div className='content'>
            {(loadingFetchTransactions) && (<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataTransactions}
                columnConfig={columnConfig}
                // handleClicks
                // Funciones
            />
        </div>
    )
}
